var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3534 7.87513C15.2155 8.37507 15.2155 9.62493 14.3534 10.1249L1.93966 17.324C1.07759 17.824 1.17741e-06 17.1991 1.22112e-06 16.1992L1.85049e-06 1.80083C1.89419e-06 0.800941 1.07759 0.176013 1.93966 0.675955L14.3534 7.87513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoPlay);
export default __webpack_public_path__ + "static/media/icon-video-play.5640e97409c2efe36e1f130f70a85004.svg";
export { ForwardRef as ReactComponent };